export class AppliedReward {
    membershipid: number;
    reference: string;
    label: string;
    type: string;
    value: number;
    rewardid: number;
    applied: boolean;
    quantityavailable: number;
    quantityapplied: number;
    description: string;
    fineprint: string;
    imageurl: string;
    validminutes: number;
    availableonline: boolean;
    availableoffline: boolean;
    expirationdate: string;
    externalreference: string;
    vendorrefs: [];
    items: [];
    categories: [];
}
